import tiles from '../../../../../Tiles/core/';

export default type => tiles[type];
